module.exports = __webpack_public_path__ + "media/images/TB_digitalsignature-5a356df4.png";